(function() {

  // Override the quantity counter behavior
  function initQuantityRestrictions() {
    const quantityInputs = document.querySelectorAll('.quantity__input[data-min-quantity]');

    quantityInputs.forEach(input => {
      const minQuantity = parseInt(input.dataset.minQuantity) || 1;
      const step = parseInt(input.dataset.quantityStep) || 1;

      // Set initial value to minimum if less than minimum
      if (parseInt(input.value) < minQuantity) {
        input.value = minQuantity;
      }

      // Ensure value is a multiple of step
      const currentValue = parseInt(input.value);
      if (currentValue % step !== 0) {
        input.value = Math.ceil(currentValue / step) * step;
      }

      // Add event listeners
      input.addEventListener('input', function() {
        enforceQuantityRules(this, minQuantity, step);
      });

      input.addEventListener('change', function() {
        enforceQuantityRules(this, minQuantity, step);
      });

      // Override button behavior by replacing the entire quantity counter
      const quantityCounter = input.closest('quantity-counter');
      if (quantityCounter) {
        // Clone all buttons to remove all event listeners
        const plusBtn = quantityCounter.querySelector('.quantity__plus');
        const minusBtn = quantityCounter.querySelector('.quantity__minus');

        if (plusBtn) {
          const newPlusBtn = plusBtn.cloneNode(true);
          plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);

          newPlusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const newValue = parseInt(input.value) || minQuantity;
            input.value = newValue + step;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            updateButtonStates(input, minQuantity, step);
          });
        }

        if (minusBtn) {
          const newMinusBtn = minusBtn.cloneNode(true);
          minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);

          newMinusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const newCurrentValue = parseInt(input.value) || minQuantity;
            const newValue = newCurrentValue - step;
            input.value = newValue >= minQuantity ? newValue : minQuantity;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            updateButtonStates(input, minQuantity, step);
          });
        }

        // Initial button state update
        updateButtonStates(input, minQuantity, step);
      }
    });
  }

  function enforceQuantityRules(input, minQuantity, step) {
    let value = parseInt(input.value) || minQuantity;

    // Ensure minimum quantity
    if (value < minQuantity) {
      value = minQuantity;
    }

    // Ensure value is a multiple of step
    if (value % step !== 0) {
      value = Math.ceil(value / step) * step;
    }

    // Update input if value changed
    if (parseInt(input.value) !== value) {
      input.value = value;
    }

    // Update button states
    updateButtonStates(input, minQuantity, step);
  }

  function updateButtonStates(input, minQuantity, step) {
    const currentValue = parseInt(input.value) || minQuantity;
    const quantityCounter = input.closest('quantity-counter');
    
    if (quantityCounter) {
      const minusBtn = quantityCounter.querySelector('.quantity__minus');
      
      if (minusBtn) {
        // Disable minus button if current value equals minimum quantity
        if (currentValue <= minQuantity) {
          minusBtn.disabled = true;
          minusBtn.setAttribute('disabled', '');
        } else {
          minusBtn.disabled = false;
          minusBtn.removeAttribute('disabled');
        }
      }
    }
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantityRestrictions);
  } else {
    initQuantityRestrictions();
  }

  // Re-initialize when variant changes (for cases where the form is updated)
  document.addEventListener('theme:variant:change', initQuantityRestrictions);

})();
